// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__za0N2","title":"ClientReferral_title__1IlAQ","itemText":"ClientReferral_itemText__1T6TY"};